import { useContext, useEffect } from "react";
import { LayoutContext } from "../contexts/LayoutContext";
import Help from "../components/Help/Manual/Help";
function HelpPage() {
    const { setIsContentScrollable } = useContext(LayoutContext);
    useEffect(() => {
        setIsContentScrollable(true);
      
        return () => {
          setIsContentScrollable(true);
        };
      }, [setIsContentScrollable]);

    return (
        <div>
            <Help />
        </div>
    )
}

export default HelpPage;